var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.useMobileWarehouse)?_c('warehouse-mobile'):(_vm.useDesktopWarehouse)?_c('warehouse-desktop'):_c('warehouse-legacy',{attrs:{"show-new-view":_vm.useLegacyDesktop},on:{"new-view":_vm.useNewView}})
}
var staticRenderFns = []

export { render, staticRenderFns }